import type { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

/**
 * SettingsLayout
 * Classification: custom (template)
 *
 * Two-column settings page: a section navigation list on the left and the
 * active section's content on the right.
 */
export interface SettingsSection {
  id: string;
  label: string;
}

export interface SettingsLayoutProps {
  title?: string;
  sections: SettingsSection[];
  activeId?: string;
  onSelect?: (id: string) => void;
  children: ReactNode;
}

export function SettingsLayout({
  title = 'Settings',
  sections,
  activeId,
  onSelect,
  children,
}: SettingsLayoutProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="h4" sx={{ fontFamily: 'inherit' }}>
        {title}
      </Typography>
      <Box sx={{ display: 'flex', gap: 4 }}>
        <Box sx={{ width: 220, flexShrink: 0 }}>
          <List disablePadding>
            {sections.map((s) => (
              <ListItemButton
                key={s.id}
                selected={s.id === activeId}
                onClick={() => onSelect?.(s.id)}
                sx={{ borderRadius: 1, mb: 0.5 }}
              >
                <ListItemText primary={s.label} />
              </ListItemButton>
            ))}
          </List>
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
      </Box>
    </Box>
  );
}
